import Link from 'next/link'
import styled from 'styled-components'
import { TOP_BAR_HEIGHT_DESKTOP, TOP_BAR_HEIGHT_MOBILE } from '@/constant/ui'

export const Wrapper = styled.nav`
  background: white;
  padding: 0 25px;
  width: 100%;
  box-sizing: border-box;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    padding: 16px;
    height: 68px;
  }
`
export const TopbarContainer = styled.div`
  position: fixed;
  background: white;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 4;
`

export const BodySpacer = styled.div<{ height: number }>`
  height: ${({ height }) => height}px;
`
export const MenuContainer = styled.div`
  display: flex;
  align-items: center;

  & img {
    margin-right: 40px;
  }
`
export const BurgerLine = styled.div`
  background: var(--brand-secondary);
  width: 20px;
  height: 2px;
  border-radius: 5px;
  position: absolute;
  left: 0;
  transition: 0.3s var(--cubicBezier);

  &:nth-child(1) {
    top: 0;
  }
  &:nth-child(2) {
    top: 50%;
    transform: translateY(-50%);
  }
  &:nth-child(3) {
    top: auto;
    bottom: 0;
  }
`
export const Burger = styled.div<{ isToggled: boolean }>`
  margin-right: 20px;
  width: 20px;
  height: 14px;
  position: relative;
  cursor: pointer;
  transition: 0.3s var(--cubicBezier);

  ${({ isToggled }) =>
    isToggled &&
    `
    .line-1 {
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%) rotate(45deg);
    }
    .line-2 {
      opacity: 0;
    }
    .line-3 {
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%) rotate(-45deg);
    }
  `}

  &:hover {
    transform: scale(1.1);
  }
`
export const MenuItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 16px;
  margin-right: 30px;
  cursor: pointer;
  text-transform: capitalize;

  a {
    text-decoration: none;
    color: var(--brand-secondary);
  }

  svg {
    margin-left: 8px;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`
export const MenuItemText = styled.span`
  @media (max-width: 1024px) {
    display: none;
  }
`
export const MenuItemLink = styled(Link)`
  @media (max-width: 1024px) {
    display: none;
  }
`
export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`
export const ClearSearch = styled.svg`
  width: 20px;
  height: 20px;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 15px;
  cursor: pointer;

  @media (max-width: 768px) {
    right: 35px;
  }
`
export const SearchButton = styled.button`
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: var(--brand-secondary);
  color: white;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 6px;
  font-size: 11px;

  @media (max-width: 768px) {
    display: none;
  }
`
export const SearchTrigger = styled.div`
  display: none;
  cursor: pointer;
  display: block;
`
export const Icons = styled.div`
  align-items: center;
  display: flex;

  svg {
    width: 24px;
    height: 24px;
  }

  & > *:not(:last-child) {
    margin-right: 10px;
  }

  @media (max-width: 768px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }
`
export const UserInitials = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--brand-primary);
  font-size: 12px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  cursor: pointer;
`

export const DesktopLogo = styled.div`
  display: block;

  @media (max-width: 1200px) {
    display: none;
  }
`

export const MobileLogo = styled.div`
  display: none;

  @media (max-width: 1200px) {
    display: block;
  }
`
export const MenuLink = styled(Link)`
  font-size: 16px;
  line-height: 1.1;
  color: black;
  display: block;
  text-decoration: none;
  width: fit-content;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-left: -2px;
  }
`

export const ImageWrapper = styled.div`
  padding-top: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: -10px;
`

export const VelocityPoints = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--brand-primary);
  font-size: 12px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  cursor: pointer;
`

export const VelocityIcon = styled.span`
  position: absolute;
  right: 110px;
  top: -2px;

  @media (min-width: 375px) {
    right: 115px;
  }
`

export const Points = styled.div`
  font-size: 14px;
  font-weight: 600;
`

export const PointValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: red;
`

export const UserName = styled.div`
  width: 100%;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5em;
`

export const Email = styled.div`
  font-size: 14px;
  padding-bottom: 10px;
`

export const Reservations = styled.div`
  list-style: none;
  padding: 16px 0;
  display: flex;
  align-items: center;
`

export const DropdownUserWrapper = styled.div`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const PointsWrapper = styled.div`
  display: flex;
  gap: 6px;
  & > svg {
    margin-top: 1px;
  }
`
